var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id == 10)?_c('Monteria',{attrs:{"municipio_id":_vm.id}}):_vm._e(),(_vm.id == 222)?_c('Cerete',{attrs:{"municipio_id":_vm.id}}):_vm._e(),(_vm.id == 291)?_c('Covenas',{attrs:{"municipio_id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }